/**
 * 🛡️ ERROR BOUNDARY - COMPONENTE PARA MANEJAR ERRORES DE REACT
 * 
 * Este componente captura errores de React y previene que bloqueen la UI
 */

import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // ✅ ACTUALIZAR EL ESTADO PARA MOSTRAR LA UI DE FALLBACK
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // ✅ REGISTRAR EL ERROR
    console.warn('🛡️ Error capturado por ErrorBoundary:', error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });

    // ✅ NOTIFICAR AL USUARIO DE FORMA NO INTRUSIVA
    if (window.showNotification) {
      window.showNotification('Se detectó un error, pero la aplicación continúa funcionando', 'warning');
    }
  }

  render() {
    if (this.state.hasError) {
      // ✅ UI DE FALLBACK PERSONALIZADA
      return this.props.fallback || (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '1px solid #ff9800',
          borderRadius: '4px',
          backgroundColor: '#fff3e0',
          color: '#e65100'
        }}>
          <h3>
            <span role="img" aria-label="Advertencia">⚠️</span> Error detectado
          </h3>
          <p>Se ha detectado un error, pero la aplicación continúa funcionando.</p>
          {this.state.error?.message ? (
            <p style={{ fontSize: 13, wordBreak: "break-word" }}>{String(this.state.error.message)}</p>
          ) : null}
          <button 
            onClick={() => this.setState({ hasError: false })}
            style={{
              padding: '8px 16px',
              backgroundColor: '#ff9800',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
